import { IconDefinition, IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';

const faMilkBottleSlash: IconDefinition = {
    icon: [
        // SVG viewbox width (in pixels)
        640,

        // SVG viewbox height (in pixels)
        512,

        // Aliases (not needed)
        [],

        // Unicode as hex value (not needed)
        '',

        // SVG path data
        'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1L232.9 157.3c2.3-1.8 4.7-3.4 7.1-5.1V46.6c-9.3-3.3-16-12.1-16-22.6c0-13.3 10.7-24 24-24H392c13.3 0 24 10.7 24 24c0 10.4-6.7 19.3-16 22.6V152.2C438.6 178 464 222 464 272v66.4L630.8 469.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM176 272c0-11.8 1.4-23.2 4.1-34.1L224 272.5V448c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V423.8l46.8 36.8C456.9 489.9 431 512 400 512H240c-35.3 0-64-28.7-64-64V272zm96.1-84.1L416 300.7V272c0-33.2-16.9-62.6-42.7-79.9C360 183.2 352 168.3 352 152.2V48H288V152.2c0 13.7-5.9 26.7-15.9 35.7zm-17.8 38.7s0 0-11.3-16.5s-11.3-16.5-11.3-16.5l0 0 0 0 .1-.1c.1 0 .1-.1 .2-.2c.2-.1 .4-.3 .7-.5c.6-.4 1.4-.9 2.4-1.5c2-1.2 4.7-2.7 8.1-4.4c6.8-3.3 16.6-7.3 28.4-10c23.8-5.4 56.5-5.4 89.4 16.4c11.4 7.6 20 10 25.9 10.5c5.8 .5 10.1-.9 13.6-2.7c3.6-1.9 6.5-4.7 8.5-7.1c1-1.2 1.7-2.2 2.1-2.8c.2-.3 .3-.5 .4-.6c0 0 0 0 0 0s0 0 0 0s0 0 0 .1l0 .1 0 0 0 0c0 0 0 0 17.6 9.5s17.6 9.5 17.6 9.5l0 0 0 .1c0 0 0 .1-.1 .1c0 .1-.1 .2-.2 .3c-.1 .2-.3 .5-.4 .8c-.3 .6-.8 1.3-1.4 2.2c-1.1 1.7-2.8 4.1-5 6.6c-4.3 5.1-10.9 11.5-20.2 16.5c-9.5 5.1-21.5 8.4-35.6 7.3c-14-1.1-29-6.5-44.8-17c-21.6-14.3-42.4-14.3-58.5-10.7c-8.1 1.8-14.9 4.6-19.6 6.9c-2.3 1.1-4.1 2.1-5.3 2.8c-.6 .3-1 .6-1.2 .7c-.1 .1-.2 .1-.2 .1l0 0s0 0 0 0l0 0 0 0 0 0z',
    ],
    iconName: 'faMilkBottleSlash' as IconName,
    prefix: 'simple-icons' as IconPrefix,
};

export default faMilkBottleSlash;
